import { useCallback } from 'react'
import { DashboardDateFilterBar, type DashboardFilterKind } from './DashboardDateFilterBar'
import type { DashboardGetParams } from '@/lib/utils/dashboardQueryParams'

export type BudgetKpiDateFilterType = 'weekly' | 'daily'

export type BudgetKpiDateRange = {
  transaction_date_from: string
  transaction_date_to: string
}

export type BudgetKpiFilterState = BudgetKpiDateRange & {
  dateFilterType: BudgetKpiDateFilterType
}

function toBudgetDateRange(params: DashboardGetParams): BudgetKpiDateRange {
  if ('date' in params) {
    return { transaction_date_from: params.date, transaction_date_to: params.date }
  }
  if ('year' in params) {
    return {
      transaction_date_from: `${params.year}-01-01`,
      transaction_date_to: `${params.year}-12-31`,
    }
  }
  return {
    transaction_date_from: params.date_from,
    transaction_date_to: params.date_to,
  }
}

function toDateFilterType(filterKind: DashboardFilterKind): BudgetKpiDateFilterType {
  return filterKind === 'week' ? 'weekly' : 'daily'
}

interface BudgetKpiDateFilterBarProps {
  onDateRangeChange: (state: BudgetKpiFilterState) => void
}

export function BudgetKpiDateFilterBar({ onDateRangeChange }: BudgetKpiDateFilterBarProps) {
  const handleQueryChange = useCallback(
    (params: DashboardGetParams, filterKind: DashboardFilterKind) => {
      onDateRangeChange({
        ...toBudgetDateRange(params),
        dateFilterType: toDateFilterType(filterKind),
      })
    },
    [onDateRangeChange]
  )

  return <DashboardDateFilterBar defaultFilterKind="week" onQueryChange={handleQueryChange} />
}
